<template>
  <common-dialog ref="dialog" width="600px" show-save-button title="修改备注" @edit-opened="onEditOpened" :data="data"
    :save-func="getDataFunc" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="买家备注" prop="买家备注">
        <el-input v-model="data.买家备注" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item label="卖家备注" prop="卖家备注">
        <el-input v-model="data.卖家备注" placeholder="请输入备注"></el-input>
      </el-form-item>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      // api: require('@/api/ent/dp').default,
      data: {
        ids: [],
        买家备注: "",
        卖家备注: "",
      },
    };
  },
  methods: {
    onEditOpened(data) {
      console.log("data", data);
      // this.data.ids = { ...data }
    },
    getDataFunc() {
      return new Promise((resolve, reject) => {
        resolve({ Code: 0, Msg: null })
      })
    },
  },
};
</script>
